import { memo } from 'react';
import { Pause, Play } from '@music-vine/cadence/icons';
import type { MouseEventHandler } from 'react';
interface PlayButtonProps {
  isPlaying?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
}
const PlayButton = memo(({
  isPlaying,
  onClick
}: PlayButtonProps) => <button aria-label={isPlaying ? 'Pause' : 'Play'} className="flex h-8 w-8 items-center justify-center rounded-full text-gray-100 transition-colors hover:cursor-pointer hover:text-white focus:outline-hidden focus-visible:ring-2 focus-visible:ring-pink-500 focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-testid="video-play-pause-button" onClick={onClick} type="button">
    {isPlaying ? <Pause className="h-8 fill-current stroke-1" /> : <Play className="h-8 fill-current stroke-1" />}
  </button>);
PlayButton.displayName = 'PlayButton';
export default PlayButton;